import type React from 'react'
import { IconOverlayButton } from './IconOverlayButton/IconOverlayButton'
import { TextOnlyOverlayButton } from './TextOnlyOverlayButton/TextOnlyOverlayButton'
import {
	type OverlayButtonIconProps,
	type OverlayButtonTextProps,
	OverlayButtonVariant,
} from './types'

export function OverlayButton(
	props: OverlayButtonIconProps | OverlayButtonTextProps
): React.ReactNode {
	if (props.variant === OverlayButtonVariant.TextOnly) {
		return <TextOnlyOverlayButton {...props} />
	}

	return <IconOverlayButton {...props} />
}
